import React from 'react';
import Style from './waveform-player.scss';

import { FontIcon } from '../font-icon/font-icon';

class WaveformPlayer extends React.Component {
  constructor() {
    super(...arguments);

    this.state = {
      isPlaying: false,
      currentDuration: 0
    }

    this.handleTrackEvent = (event) => {
      const previousTrackPercentage = 0;
      switch (event.eventType) {
        case "error": {
          //alert("Unable to play audio track.")
          break;
        }
        case "playing": {
          this.setState({ isPlaying: true });
          this.forceUpdate();
          break;
        }
        case "loadstart": {
          this.setState({ isPlaying: false });
          this.forceUpdate();
          break;
        }
        case "canplay": {
          if (this.tracker) {
            this.tracker.style.display = 'block';
          }
          break;
        }
        case "progress": {
          if (this.loaded) {
            this.loaded.style.clip = `rect(0px,${event.percentage * 400}px,30px,0px)`
          }
          break;
        }
        case "timeupdate": {
          this.setState({ currentDuration: event.current });

          this.props.onTrackPlayed(this.props.track.Id, event.current);

          if (this.playback && this.tracker) {
            this.setState({ isPlaying: true });
            this.playback.style.clip = `rect(0px,${event.percentage * 400}px,30px,0px)`
            this.playback.style.display = 'block';
            this.loaded.style.clip = `rect(0px,${event.loaded * 400}px,30px,0px)`
            this.loaded.style.display = 'block';
            this.tracker.style.left = (event.percentage * 100) + '%';
            this.tracker.style.display = 'block';
            this.previousTrackPercentage = event.percentage * 400;
            // this.storePreviousTrackDetails(this.previousTrackPercentage);
            if (this.previousTrackPercentage === 400) {
              this.playback.style.clip = `rect(0px,0px,30px,0px)`;
              this.tracker.style.left = 0;
              this.tracker.style.display = 'none';
              this.setState({ currentDuration: 0 });
            }
            this.forceUpdate();
          }
          break;
        }
        case "paused": {
          this.setState({ isPlaying: false });
          this.forceUpdate();
          break;
        }

        case "ended": {
          this.setState({ isPlaying: false });
          if (this.playback && this.tracker) {
            this.playback.style.clip = `rect(0px,0px,30px,0px)`
            this.tracker.style.display = 'none';
            this.tracker.style.left = 0;
            this.loaded.style.clip = `rect(0px,${this.previousTrackPercentage}px,30px,0px)`;
            this.setState({ currentDuration: 0 });
            // this.storePreviousTrackDetails(this.previousTrackPercentage)
          }
          this.forceUpdate();
          break;
        }
      }
    }
    this.state = {
      isPlaying: false,
      currentDuration: 0
    }
  }

  componentDidMount() {
    Common.TrackPlayer.RegisterTrackNotifications(this.props.track.Id, this.handleTrackEvent);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.track != this.props.track) {
      Common.TrackPlayer.UnregisterTrackNotifications(this.props.track.Id, this.handleTrackEvent);
      Common.TrackPlayer.RegisterTrackNotifications(nextProps.track.Id, this.handleTrackEvent);
      this.setState({ isPlaying: false });
    } else {
      this.reset()
    }
  }

  componentWillUnmount() {
    Common.TrackPlayer.UnregisterTrackNotifications(this.props.track.Id, this.handleTrackEvent);
    this.reset()
  }

  reset = () => {
    Common.TrackPlayer.Stop();
    this.playback.style.clip = `rect(0px,0px,30px,0px)`
    this.tracker.style.display = 'none';
    this.tracker.style.left = 0;
    this.loaded.style.clip = `rect(0px,0px,30px,0px)`;
    this.setState({ currentDuration: 0, isPlaying: false });
  }

  handlePlayTrack(event) {

    if (!this.props.track.S3Url) {
      return
    }

    this.timer = Date.now();
    Common.TrackPlayer.AudioSource = this.props.source;
    Common.TrackPlayer.Play(this.props.track);
    this.storeAuditionedTrack();
  }

  storeAuditionedTrack() {
    let auditioned_history = localStorage.getItem('audition-history');
    if (auditioned_history) {
      auditioned_history = JSON.parse(auditioned_history);
      auditioned_history.push(this.props.track.Id);
    } else {
      auditioned_history = [this.props.track.Id];
    }
    localStorage.setItem('audition-history', JSON.stringify(auditioned_history));
  }

  handlePauseTrack() {
    Common.TrackPlayer.Pause();
  }

  handleMissingImage(event) {
    const { url, missingImageUrl = null } = this.props;
    event.target.src = 'data:image/png;base64,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';
  }

  handleWaveformClick(track, event) {
    const rect = event.target.getBoundingClientRect();
    const posMultiplier = window.outerWidth > 1500 ? 1 : 1.25;
    const posAsPercent = ((event.nativeEvent.offsetX * posMultiplier) / rect.width);
    Common.TrackPlayer.AudioSource = this.props.source;
    Common.TrackPlayer.Play(track, posAsPercent);
    // Common.UserInterface.SetAuditionedStatus(this.props.track, 0);
    this.storeAuditionedTrack();
  }

  handlePlayTrackFromStart(event) {
    this.timer = Date.now();
    Common.TrackPlayer.Stop();
    this.setState({ currentDuration: 0 });
    Common.TrackPlayer.AudioSource = this.props.source;
    Common.TrackPlayer.Play(this.props.track);
    // Common.UserInterface.SetAuditionedStatus(this.props.track, 0);
    this.storeAuditionedTrack();
  }

  GetWaveformUrl = (track) => {
    return track.S3Url ? track.S3Url.replace(".mp3", ".png").replace(/[+]/g,"%2B") : "";
  }

  render() {
    const {
      onTrackPlayed,
      track,
      width = 400,
      height = 30,
    } = this.props;

    const waveformUrl = this.GetWaveformUrl(track)
    const playerButtonStyle = {
      width: `${100}%`,
      textAlign: "center"
    };

    if (!track) {
      return null
    }

    const playerButton = this.state.isPlaying
      ? (<FontIcon name='circle-pause' style={playerButtonStyle} color={'#87CC41'} size={25} onClick={this.handlePauseTrack.bind(this)} />)
      : (<FontIcon name='circle-play' style={playerButtonStyle} size={25} onClick={this.handlePlayTrack.bind(this)} />);

    return (
      <div className={'waveform-player'}>
        <div className={'playback-button action-button'}>{playerButton}</div>
        <div className={'playback-button-space'} onClick={this.handlePlayTrackFromStart.bind(this)}></div>
        <div className={'track-waveform'}>
          <div className={'waveform'}>
            <img src={waveformUrl} width={width} height={height} onError={this.handleMissingImage.bind(this)} />
            <img ref={(i) => { this.loaded = i }} src={waveformUrl} width={width} height={height} onError={this.handleMissingImage.bind(this)} />
            <img ref={(i) => { this.playback = i }} src={waveformUrl} width={width} height={height} onError={this.handleMissingImage.bind(this)} />
            <div className={`indicator-path wft-${track.Id}`} onClick={(e) => { this.handleWaveformClick(track, e) }}>
              <div ref={(i) => { this.tracker = i }} className='indicator' style={{ display: 'none' }} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export { WaveformPlayer }
